import { Component, computed, inject, signal } from '@angular/core';
import { AuthService } from '#services';

@Component({
  selector: 'app-home',
  imports: [],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  private _authService = inject(AuthService);

  email = signal<string>(this._authService.getAccountEmail());
  roles = computed(() => this._authService.getRoles());
  isAdmin = signal<boolean>(this._authService.isAdmin());
}
